/** init domain config */
import Vue from 'vue'
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_BASE_URL
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
window._CONFIG['extendDomainURL'] = process.env.VUE_APP_EXTEND_API_BASE_URL
window._CONFIG['foodDomainURL'] = process.env.VUE_APP_FOOD_API_BASE_URL
window._CONFIG['vtjDomainURL'] = process.env.VUE_APP_VTJ_API_BASE_URL
window._CONFIG['chooseSeatDomainURL'] = process.env.VUE_APP_CHOOSESEAT_API_BASE_URL
//单点登录地址
window._CONFIG['casPrefixUrl'] = process.env.VUE_APP_CAS_BASE_URL
window._CONFIG['onlinePreviewDomainURL'] =  process.env.VUE_APP_ONLINE_BASE_URL
window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL+ '/sys/common/pdf/pdfPreviewIframe'
//内网标记
window._CONFIG['netType'] = process.env.VUE_APP_NET_TYPE